import React from "react";
import HelpCenter from "../reusble_components/helpCenter";
import spotmies_banner from "../../assests/spotmies_banner.png";
import spotmies_banner1 from "../../assests/spotmies_banner1.png";
const Footer = () => {
  return (
    <div className=" p-6 absolute bottom-0 md:relative md:flex md:items-end w-full   justify-center opacity-70 pd-4">
      <div className="">
        <div className="flex  justify-center filter p-4 opacity-90 ">
          <img
            src={spotmies_banner1}
            className="object-cover h-7 w-35 flex  justify-center"
            alt="logo"
          />
        </div>
        <div className="flex  justify-center space-x-2 opacity-70 text-xs">
          <a
            className="hover:text-primary underline"
            href="https://app.reaidy.io/TermsOfUse"
            // target="_blank"
            rel="noopener noreferrer"
          >
            Terms of use
          </a>
          <span>|</span>{" "}
          <a
            className="hover:text-primary underline"
            href="https://app.reaidy.io/PrivacyPolicy"
            // target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy 
          </a>
        </div>
      </div>
      <HelpCenter position="/" />
    </div>
  );
};
export default Footer;
